// extracted by mini-css-extract-plugin
export var dividerLine = "_9f-3";
export var itemImage = "_9f-9";
export var lightDivider = "_9f-4";
export var modalContent = "_9f-5";
export var modalContentCompact = "_9f-6";
export var productCard = "_9f-a";
export var productImage = "_9f-b";
export var productImageCompact = "_9f-7";
export var productImagePlaceholder = "_9f-c";
export var productImagePlaceholderCompact = "_9f-8";
export var progressBarBackground = "_9f-1";
export var progressBarContainer = "_9f-0";
export var progressBarFill = "_9f-2";